import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PerformanceSwiper from "./performance-swiper";

type PerformanceProps = {
  performanceData: Performance[];
  showDetails?: boolean;
  onDetailsClicked?: () => void;
  selectedAccount: any;
  selectedPortfolio: any;
};

const PerformanceComponent: React.FC<PerformanceProps> = ({
  performanceData,
  showDetails = false,
  onDetailsClicked,
  selectedAccount,
  selectedPortfolio,
}: PerformanceProps) => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (selectedAccount && selectedPortfolio) {
      setData(
        performanceData.filter(
          (item: any) => item.portfolioCode === selectedPortfolio?.accountCode
        )
      );
    } else {
      setData(performanceData);
    }
  }, [selectedPortfolio, performanceData]);

  return (
    <div
      className={clsx(
        " w-full p-4 bg-white rounded-xl slide-left add-shadow border border-[#e3e3e3] flex-col justify-start items-start gap-5 inline-flex overflow-hidden",
        showDetails ? "h-fit" : "h-[272px]",
        data?.length ? "mt-3" : "mt-0"
      )}
    >
      {data?.length ? (
        <PerformanceSwiper
          performanceData={data}
          onDetailsClicked={onDetailsClicked}
          selectedAccount={selectedAccount}
          selectedPortfolio={selectedPortfolio}
        />
      ) : (
        <div className="flex flex-col flex-grow justify-center items-center w-full min-h-[250px]">
          <img
            src={"/images/empty-performance-icon.svg"}
            width={40}
            height={40}
            alt="Empty Performance Icon"
          />
          <p className="text-neutral-400 text-sm mt-3">
            You have no performance yet
          </p>
        </div>
      )}
    </div>
  );
};

export default PerformanceComponent;
